import { usePage } from '@inertiajs/react';
import React from 'react';
import DriveSyncLayout from '../../layouts/DriveSyncLayout';
import DataStreamsHeader from './DataStreamsHeader';
import DataStreamsTable from './DataStreamsTable';

export default function Index() {
  const { props } = usePage();

  return (
    <DriveSyncLayout>
      <DataStreamsHeader showImportButton />
      <DataStreamsTable data_streams={props.data_streams} />
    </DriveSyncLayout>
  );
} 